"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChildren = void 0;
var dom_utilities_1 = require("@fluentui/dom-utilities");
Object.defineProperty(exports, "getChildren", { enumerable: true, get: function () { return dom_utilities_1.getChildren; } });
//# sourceMappingURL=getChildren.js.map